/* eslint-disable react-hooks/exhaustive-deps */
import { faFileLines } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import peticionBack from "../../../../libs/peticiones/peticionBack";
import { Modal, toaster, Steps, Panel, Row, Col } from "rsuite";
import { Folder } from "../../../../types/filemanager/Folder";
import { TipoDocumento } from "../../../../types/filemanager/TipoDoc";
import * as Yup from "yup";
import { useFormik } from "formik";
import { FileType } from "rsuite/esm/Uploader";
import { Instancia } from "../../../../types/compl-archivos/Instancia";
import { Sistema } from "../../../../types/admin-usuarios/Sistema";
import { Region } from "../../../../types/compl-archivos/Region";
import FileScreen from "./views/FileScreen";
import InfoCaseScreen from "./views/InfoCaseScreen";
import InfoDocumentScreen from "./views/InfoDocumentScreen";
import { jurisprudenceTypes } from "../../../../libs/jurisprudenceData/Jurisprudences";
import { FormUpload } from "../../../../types/compl-archivos/FormUpload";
import { TypeDocumentId } from "../../../../enums/TypeDocumentId";
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons";
import { NextPrevButtons } from "./components/NextPrevButtons";

const defaultForm: FormUpload = {
  file: null,
  tag: "",
  number: "",
  year: "",
  sistema: "",
  instancia: "",
  childhood: false,
  genre: false,
  relevantCase: false,
  intercultural: false,
  olderPerson: false,
  disabilityPerson: false,
  migrant: false,
  sexual: false,
  subject: "",
  judgments: [],
  dateRegistration: "",
  dateExecution: "",
  region: "",
  district: "",
  area: "",
  folderType: "",
  folder: "",
  jurisprudence: "",
  jurisprudenceKey: "",
  jurisprudenceType: "",
  epoch: "",
  datePublication: "",
};

const formSchema = Yup.object().shape({
  tag: Yup.string().required("Seleccione una etiqueta"),
  file: Yup.mixed().required("Cargue un archivo"),
  number: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (
      validTags(tag[0], [
        "657748cb08c57c5d952cfb5a",
        "65846bec7f2c7be3ada5ba6c",
      ])
    ) {
      return schema.required("Número de expediente");
    }
    return schema.notRequired();
  }),
  jurisprudence: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (
      tag[0] !== undefined &&
      tag[0].includes(TypeDocumentId.JURISPRUDENCIAS)
    ) {
      return schema.required("Escriba una jurisprudencia");
    }
    return schema.notRequired();
  }),
  jurisprudenceKey: Yup.string().when(
    "tag",
    (tag: string | string[], schema) => {
      if (
        tag[0] !== undefined &&
        tag[0].includes(TypeDocumentId.JURISPRUDENCIAS)
      ) {
        return schema.required("Escriba una clave de jurisprudencia");
      }
      return schema.notRequired();
    }
  ),
  jurisprudenceType: Yup.string().when(
    "tag",
    (tag: string | string[], schema) => {
      if (
        tag[0] !== undefined &&
        tag[0].includes(TypeDocumentId.JURISPRUDENCIAS)
      ) {
        return schema.required("Seleccione una jurisprudencia");
      }
      return schema.notRequired();
    }
  ),
  datePublication: Yup.string().when(
    "tag",
    (tag: string | string[], schema) => {
      if (
        tag[0] !== undefined &&
        tag[0].includes(TypeDocumentId.JURISPRUDENCIAS)
      ) {
        return schema.required("Seleccione una fecha de publicación");
      }
      return schema.notRequired();
    }
  ),
  epoch: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (
      tag[0] !== undefined &&
      tag[0].includes(TypeDocumentId.JURISPRUDENCIAS)
    ) {
      return schema.required("Seleccione una epoca");
    }
    return schema.notRequired();
  }),
  year: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (tag[0] !== TypeDocumentId.LIBRE) {
      return schema.required("Seleccione un año");
    }
    return schema.notRequired();
  }),

  // .required("Seleccione un año"),
  dateExecution: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (
      validTag(tag[0], [TypeDocumentId.JURISPRUDENCIAS, TypeDocumentId.LIBRE])
    ) {
      return schema.required("Seleccione una fecha de excepcion");
    }
    return schema.notRequired();
  }),

  instancia: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (
      validTags(tag[0], [
        "657748cb08c57c5d952cfb5a",
        "65846bec7f2c7be3ada5ba6c",
      ])
    ) {
      return schema.required("Selecione una instancia");
    }
    return schema.notRequired();
  }),
  sistema: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (
      validTag(tag[0], [TypeDocumentId.JURISPRUDENCIAS, TypeDocumentId.LIBRE])
    ) {
      return schema.required("Seleccione un sistema");
    }
    return schema.notRequired();
  }),
  judgments: Yup.array().when("tag", (tag: string | string[], schema) => {
    if (
      validTag(tag[0], [TypeDocumentId.JURISPRUDENCIAS, TypeDocumentId.LIBRE])
    ) {
      return schema.min(1, "Seleccione al menos un delito");
    }
    return schema.notRequired();
  }),
  region: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (validTag(tag[0], [TypeDocumentId.LIBRE])) {
      return schema.required("Selecione una región");
    }
    return schema.notRequired();
  }),
  district: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (
      validTag(tag[0], [TypeDocumentId.JURISPRUDENCIAS, TypeDocumentId.LIBRE])
    ) {
      return schema.required("Selecione un distrito");
    }
    return schema.notRequired();
  }),
  area: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (
      validTag(tag[0], [TypeDocumentId.JURISPRUDENCIAS, TypeDocumentId.LIBRE])
    ) {
      return schema.required("Selecione una área");
    }
    return schema.notRequired();
  }),
  folderType: Yup.string().when("tag", (tag: string[], schema) => {
    if (
      validTag(tag[0], [TypeDocumentId.JURISPRUDENCIAS, TypeDocumentId.LIBRE])
    ) {
      return schema.required("Seleccione una carpeta");
    }
    return schema.notRequired();
  }),
  subject: Yup.string().when("tag", (tag: string | string[], schema) => {
    if (validTag(tag[0], [TypeDocumentId.LIBRE])) {
      return schema.required("Ingrese un asunto");
    }
    return schema.notRequired();
  }),
});

function validTag(val: string, ext?: Array<string>) {
  return !["65846bec7f2c7be3ada5ba6c", ...(ext || [])].includes(val);
}
function validTags(val: string, tags: Array<String>) {
  return tags.includes(val);
}

export default function UploadFile({
  setLoading,
  updateFolders,
  currFolder,
}: {
  setLoading: any;
  updateFolders: Function;
  currFolder?: Folder;
}) {
  const [modal, setModal] = useState<boolean>(false);
  const [tipos, setTipos] = useState<TipoDocumento[]>([]);
  const [instancias, setInstancias] = useState<Instancia[]>([]);
  const [sistemas, setSistemas] = useState<Sistema[]>([]);
  const [delitos, setDelitos] = useState<any>([]);
  const [regiones, setRegiones] = useState<Region[]>([]);
  const [distritos, setDistritos] = useState<any>({});
  const [areas, setAreas] = useState<any>({});
  const [tiposCarpeta, setTiposCarpeta] = useState<any[]>([]);
  const [materias, setMaterias] = useState<any[]>([]);
  const [epocas, setEpocas] = useState<any[]>([]);

  const [step, setStep] = useState(0);
  const onChangeNumber = (nextStep: number) => {
    setStep(nextStep < 0 ? 0 : nextStep > 3 ? 3 : nextStep);
  };

  const onNext = () => onChangeNumber(step + 1);
  const onPrevious = () => onChangeNumber(step - 1);

  useEffect(() => {
    getTipos();
    getInstancias();
    getSistemas();
    getRegiones();
    getTypeFolder();
    getMaterias();
    getEpocas();
  }, []);

  async function getEpocas() {
    const res = await peticionBack({}, "/epochs", "GET", false, toaster);
    if (res) setEpocas([...res.data]);
  }

  async function getTipos() {
    const res = await peticionBack(
      {},
      // `/tags?query=%7B%22_id%22%3A%7B%22%24in%22%3A%20%5B%2TypeDocumentId.JURISPRUDENCIAS22%2C%20%2265846bec7f2c7be3ada5ba6c%22%2C%20%22657748cb08c57c5d952cfb5a%22%5D%7D%7D`,

      `/tags?query=${encodeURIComponent(
        JSON.stringify({
          _id: {
            $in: [
              TypeDocumentId.ACUERDO,
              TypeDocumentId.JURISPRUDENCIAS,
              TypeDocumentId.SENTENCIAS,
              TypeDocumentId.LIBRE,
            ],
          },
        })
      )}`,

      "GET",
      false,
      toaster
    );
    if (res) setTipos([...res.data]);
  }

  async function getInstancias() {
    const res = await peticionBack({}, "/instancias", "GET", false, toaster);
    if (res) setInstancias([...res.data]);
  }

  async function getSistemas() {
    const res = await peticionBack({}, "/sistemas", "GET", false, toaster);
    if (res) setSistemas([...res.data]);
  }

  async function getRegiones() {
    const res = await peticionBack({}, "/regiones", "GET", false, toaster);
    if (res) setRegiones([...res.data]);
  }

  async function getTypeFolder() {
    const res = await peticionBack({}, "/tiposcarpeta", "GET", false, toaster);
    if (res) setTiposCarpeta([...res.data]);
  }

  async function getMaterias() {
    const res = await peticionBack({}, "/materias", "GET", false, toaster);
    if (res) setMaterias([...res.data]);
  }

  /* FORMIK */
  const {
    handleSubmit,
    handleReset,
    handleBlur,
    setFieldValue,
    values,
    errors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: defaultForm,
    validationSchema: formSchema,
    onSubmit: () => upload(),
    onReset: () => {},
  });

  useEffect(() => {
    if (values.region) {
      getDistritos(values.region);
    } else {
      setDistritos([]);
      setFieldValue("district", "");
    }
  }, [values.region]);

  useEffect(() => {
    if (values.district) {
      getAreas(values.district);
    } else {
      setAreas([]);
      setFieldValue("area", "");
    }
  }, [values.district]);

  useEffect(() => {
    if (values.subject) {
      getDelitos(values.subject);
    } else {
      setDelitos([]);
      setFieldValue("judgments", []);
    }
  }, [values.subject]);

  useEffect(() => {
    if (values.tag === TypeDocumentId.ACUERDO) {
      setFieldValue("region", "65de186c8da4d9ad2ddab428");
      setFieldValue("district", "65de186c8da4d9ad2ddab42c");
      setFieldValue("area", "658473ba7f2c7be3ada5bb4a");
      setFieldValue("subject", "6584705a7f2c7be3ada5bae2");
      setFieldValue("dateExecution", "");
      setFieldValue("dateRegistration", "");
      setFieldValue("folder", "");
      setFieldValue("instancia", "");
      setFieldValue("judgments", []);
      setFieldValue("year", "");
      setFieldValue("sistema", "");
      setFieldValue("number", "");
      setFieldValue("folderType", "");
      setFieldValue("folder", "");
      setFieldValue("epoch", "");
    } else {
      setFieldValue("region", "65de186c8da4d9ad2ddab428");
      setFieldValue("district", "65de186c8da4d9ad2ddab42c");
      setFieldValue("area", "");
      setFieldValue("subject", "");
      setFieldValue("area", "");
      setFieldValue("dateExecution", "");
      setFieldValue("dateRegistration", "");
      setFieldValue("folder", "");
      setFieldValue("instancia", "");
      setFieldValue("judgments", []);
      setFieldValue("year", "");
      setFieldValue("sistema", "");
      setFieldValue("number", "");
      setFieldValue("folderType", "");
      setFieldValue("folder", "");
      setFieldValue("epoch", "");
      setFieldValue("subject", "");
    }
  }, [values.tag]);

  function onChange({ target }: any) {
    setFieldValue(target.name, target.value);
  }

  async function getDelitos(subject: string) {
    setDelitos([]);
    setFieldValue("judgments", []);
    if (!subject) return;
    const res = await peticionBack(
      {},
      `/delitos?subject=${subject}`,
      "GET",
      false,
      toaster
    );
    if (res && res.data) setDelitos(res.data);
  }
  async function getDistritos(part: string) {
    if (distritos[part]) return;
    const res = await peticionBack(
      {},
      `/distritos?region=${part}`,
      "GET",
      false,
      toaster
    );
    if (res && res.data) saveNewCon(distritos, setDistritos, part, res.data);
  }

  async function getAreas(part: string) {
    if (areas[part]) return;
    const res = await peticionBack(
      {},
      `/areas?district=${part}`,
      "GET",
      false,
      toaster
    );
    if (res && res.data) saveNewCon(areas, setAreas, part, res.data);
  }

  function saveNewCon(get: any, set: any, key: string, data: any[]) {
    const cpy = { ...get };
    cpy[key] = data;
    set(cpy);
  }

  useEffect(() => {
    if (!modal) handleReset(null);
  }, [modal]);

  useEffect(() => {
    setFieldValue("sistema", null);
    setFieldValue("folderType", null);
    setFieldValue("number", null);
  }, [values.tag]);

  async function upload() {
    setLoading(true);
    const params = new FormData();
    const archivo = (values.file as FileType).blobFile as File;
    if (currFolder?._id) params.append("folder", currFolder?._id);

    params.append("file", archivo);
    params.append("tag", values.tag);

    if (values.tag !== TypeDocumentId.LIBRE) {
      params.append("area", values.area);
    }

    switch (
      values.tag // parametros por tipo de archivo
    ) {
      case TypeDocumentId.ACUERDO: // ACUERDO
        params.append("region", values.region);

        params.append("district", values.district);
        params.append("instance", values.instancia);

        params.append("subject", values.subject);
        params.append("number", values.number);
        params.append("year", values.year);
        break;
      case TypeDocumentId.LIBRE:
        params.append("process", JSON.stringify(true));
        params.append("publish", JSON.stringify(false));
        break;

      default:
        if (values.tag !== TypeDocumentId.JURISPRUDENCIAS) {
          // tesis
          params.append("number", values.number);
          params.append(
            "dateRegistration",
            new Date(values.dateRegistration).toISOString()
          );
          params.append(
            "dateExecution",
            new Date(values.dateExecution).toISOString()
          );
          params.append("instance", values.instancia);
          params.append("system", values.sistema);
          params.append("genre", JSON.stringify(values.genre));
          params.append("childhood", JSON.stringify(values.childhood));
          params.append("relevantCase", JSON.stringify(values.relevantCase));
          params.append("intercultural", JSON.stringify(values.intercultural));
          params.append("olderPerson", JSON.stringify(values.olderPerson));
          params.append(
            "handicappedPerson",
            JSON.stringify(values.disabilityPerson)
          );
          params.append("migrant", JSON.stringify(values.migrant));
          params.append("sexual", JSON.stringify(values.sexual));
          params.append("folderType", values.folderType);
          params.append(
            "judgments",
            JSON.stringify(
              values.judgments.map((judgment: any) => judgment._id)
            )
          );
        } else {
          params.append(
            "datePublication",
            new Date(values.datePublication).toISOString()
          );
        }
        params.append("district", values.district);
        params.append("jurisprudence", values.jurisprudence);
        params.append("jurisprudenceKey", values.jurisprudenceKey);
        params.append("jurisprudenceType", values.jurisprudenceType);
        params.append("year", values.year);
        params.append("epoch", values.epoch);
        params.append("region", values.region);
        params.append("subject", values.subject);
    }

    const res = await peticionBack(
      params,
      "/files/upload",
      "POST",
      true,
      toaster
    );
    if (res) {
      const sep = res.src.split("/");
      const ixl = sep[sep.length - 1].lastIndexOf(".");
      const clrName = sep[sep.length - 1].substring(0, ixl);
      const nFile = { ...res, name: clrName };
      updateFolders(nFile, 0);
      setModal(false);
    }

    setLoading(false);
  }

  useEffect(() => {
    if (!modal) resetForm();
    setStep(0);
  }, [modal]);

  function validateGeneralDocumentStep2() {
    return errors.subject === undefined &&
      errors.region === undefined &&
      errors.district === undefined &&
      errors.area === undefined &&
      errors.instancia === undefined &&
      errors.judgments === undefined
      ? false
      : true;
  }

  function validateStep1() {
    return errors.tag === undefined &&
      errors.file === undefined &&
      errors.folderType === undefined &&
      errors.sistema === undefined
      ? false
      : true;
  }

  function validateTesisStep2() {
    return errors.subject === undefined &&
      errors.region === undefined &&
      errors.jurisprudenceKey === undefined &&
      errors.jurisprudence === undefined &&
      errors.jurisprudenceType === undefined
      ? false
      : true;
  }
  function validateAgreementDocumentStep2() {
    return errors.instancia !== undefined;
  }

  function getDisableForPage() {
    if (step === 0) {
      return validateStep1();
    } else if (step === 1) {
      if (validateTesis(true)) {
        return validateTesisStep2();
      } else if (validateAgreement(true)) {
        return validateAgreementDocumentStep2();
      } else {
        return validateGeneralDocumentStep2();
      }
    } else if (step === 2) {
      return true;
    }
    return false;
  }

  function validateTesis(isTesis: boolean) {
    return isTesis
      ? values.tag === TypeDocumentId.JURISPRUDENCIAS
      : values.tag !== TypeDocumentId.JURISPRUDENCIAS;
  }

  function validateAgreement(isAgreement: boolean) {
    return isAgreement
      ? values.tag === TypeDocumentId.ACUERDO
      : values.tag !== TypeDocumentId.ACUERDO;
  }

  return (
    <>
      <button className="opt-menu" type="button" onClick={() => setModal(true)}>
        <img src="/images/add-file.svg" alt="new-folder" width="50" />
        <p className="">Subir archivo</p>
      </button>
      <Modal
        open={modal}
        onClose={() => setModal(false)}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="border-bottom-0 pb-0" closeButton>
          <div className="d-flex flex-row">
            <FontAwesomeIcon
              icon={faFileLines}
              size="xl"
              className="me-2 pt-1"
            />
            <h4>Nuevo documento</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} onReset={handleReset}>
            <Steps current={step}>
              <Steps.Item title="Archivo" />
              <Steps.Item title="Información" />
              <Steps.Item title="Información del archivo" />
            </Steps>

            <hr />
            <Panel>
              {step === 0 ? (
                <FileScreen
                  errors={errors}
                  handleBlur={handleBlur}
                  onChange={onChange}
                  sistemas={sistemas}
                  tipos={tipos}
                  tiposCarpeta={tiposCarpeta}
                  touched={touched}
                  values={values}
                />
              ) : step === 1 ? (
                <InfoCaseScreen
                  errors={errors}
                  handleBlur={handleBlur}
                  onChange={onChange}
                  touched={touched}
                  values={values}
                  areas={areas}
                  distritos={distritos}
                  instancias={instancias}
                  regiones={regiones}
                  delitos={delitos}
                  materias={materias}
                  setFieldValue={setFieldValue}
                  jurisprudenceTypes={jurisprudenceTypes}
                />
              ) : (
                step === 2 && (
                  <InfoDocumentScreen
                    errors={errors}
                    handleBlur={handleBlur}
                    onChange={onChange}
                    touched={touched}
                    values={values}
                    epocas={epocas}
                    validateAgreement={validateAgreement}
                  />
                )
              )}
            </Panel>
            <hr />

            {values.tag === TypeDocumentId.LIBRE ? (
              <Row className="d-flex justify-content-center ">
                <Col className="d-flex justify-content-center mt-3">
                  <Button type="submit" className="bg-success">
                    <FontAwesomeIcon
                      icon={faArrowUpFromBracket}
                      size="sm"
                      className="me-2"
                    />
                    Subir Registro
                  </Button>
                </Col>
              </Row>
            ) : (
              <NextPrevButtons
                step={step}
                onNext={onNext}
                onPrevious={onPrevious}
                getDisableForPage={getDisableForPage}
              />
              // <div
              //   className={
              //     "d-flex justify-content-" + (step !== 0 ? "between" : "end")
              //   }
              // >
              //   {step !== 0 && <Button onClick={onPrevious}>Anterior</Button>}
              //   {step !== 2 && (
              //     <Button onClick={onNext} disabled={getDisableForPage()}>
              //       Siguiente
              //     </Button>
              //   )}
              // </div>
            )}
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
